module.exports = __webpack_public_path__ + "resources/img/img_magic_line_en.25882d372e516ebcab1dcb432c9ee69c.png";